import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Paper, Image, Text, Flex, Group, Badge, Menu, ActionIcon, Modal, Anchor } from '@mantine/core'
import { useSelector } from 'react-redux'
import { adjustImageProduct, editProduct } from '../../../../services/products'
import { loadingNotification, completedLoadingNotification, failedLoadingNotification } from '../../../ui/Notifications'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import { IconTrash, IconDotsVertical, IconPencil, IconBrandYoutube } from '@tabler/icons-react'
import { modalDeleteDataUsePayload } from '../../../ui/Prompt/modalDeleteDataUsePayload'
import FormAdjustPositionImageProduct from './Helper/FormAdjustPositionImageProduct'
import FormAddImageProduct from './Form/FormAddImageProduct'
import FormAdjustVideoProduct from './Form/FormAdjustVideoProduct'
import PreviewVideoProduct from './Helper/PreviewVideoProduct'


const ProductImageAndVideo = ({ productId, reloadProduct }) => {
  const { isLoadingProduct, summary, included, minimumPayload } = useSelector(state => state.product_detail)
  // service
  const [imageProduct, setImageProduct] = useState([])
  const [adjustImagePosition, setAdjustImagePosition] = useState(false)
  const [openModalAddImage, setOpenModalAddImage] = useState(false)

  const [videoProduct, setVideoProduct] = useState([])
  const [openModalAdjustVideo, setOpenModalAdjustVideo] = useState(false)
  const [openModalPreviewVideo, setOpenModalPreviewVideo] = useState(false)
  const [detailData, setDetailData] = useState(null)

  // service
  const generatePayload = () => {
    return {
      ...minimumPayload,
    }
  }

  const onCloseModalAddImage = () => {
    setOpenModalAddImage(false)
  }

  const onCloseModalAdjustVideo = () => {
    setOpenModalAdjustVideo(false)
    setDetailData(null)
  }

  const onCloseModalPreviewVideo = () => {
    setOpenModalPreviewVideo(false)
    setDetailData(null)
  }

  const handleQuitAdjustPosition = () => {
    setAdjustImagePosition(false)
  }

  const assignImageVideoProduct = (included) => {
    const { images, videos } = included
    const includedImage = Object.values(images) || []
    const includedVideo = Object.values(videos) || []

    if (includedImage.length > 0) {
      const remapData = includedImage.map((val) => {
        return val.attributes
      })
      const sortData = remapData.sort((oldData, newData) => oldData.position - newData.position)
      setImageProduct(sortData)
    } else {
      setImageProduct([])
    }

    const getYoutubeId = (url) => {
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/)
      // eslint-disable-next-line
      return undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
    }

    const getThumbnailYoutube = (youtubeId) => {
      return `https://img.youtube.com/vi/${youtubeId}/0.jpg`
    }


    const remapDataVideo = includedVideo.map((val) => {
      const { attributes } = val
      return {
        ...attributes,
        thumbnail: getThumbnailYoutube(getYoutubeId(attributes.source)),
        link_embed: `https://www.youtube.com/embed/${getYoutubeId(attributes.source)}`
      }
    })
    setVideoProduct(remapDataVideo)
  }

  useEffect(() => {
    if (!isLoadingProduct && included) {
      assignImageVideoProduct(included)
    }
  }, [isLoadingProduct, included])


  const handlingSetMainPhoto = async (idImage) => {
    const loadingSetMainPhoto = loadingNotification('Set Main Photo Product', 'Please Wait. . .')
    const recentCreator = summary.creator.id
    const payload = {
      images: [
        {
          id: idImage,
          is_default: 1
        }
      ],
      user_ids: [recentCreator]
    }
    try {
      const response = await adjustImageProduct(productId, payload)
      if (response.success) {
        completedLoadingNotification(loadingSetMainPhoto, 'Set Main Image Product Success', 'You have been set main image product successfully')
        reloadProduct()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      failedLoadingNotification(loadingSetMainPhoto, 'Set Main Image Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    }
  }

  const handlingSetMainVideo = async (idVideo) => {
    const loadingSetMainVideo = loadingNotification('Set Main Video Product', 'Please Wait. . .')
    const payload = {
      videos: {
        id: idVideo,
        is_default: 1
      }
    }
    try {
      const response = await editProduct(productId, payload)
      if (response.success) {
        completedLoadingNotification(loadingSetMainVideo, 'Set Main Video Product Success', 'You have been set main video product successfully')
        reloadProduct()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      failedLoadingNotification(loadingSetMainVideo, 'Set Main Video Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    }
  }

  const handlingDeleteImageProduct = (valueImageProduct) => {
    const payload = generatePayload()
    payload.deleted_images = [valueImageProduct.id]
    modalDeleteDataUsePayload('Image product', productId, payload, `Image Position ${valueImageProduct.position}`, editProduct, reloadProduct)
  }

  const handlingDeleteVideoProduct = (valueVideoProduct) => {
    const payload = {
      videos: [valueVideoProduct.id]
    }
    modalDeleteDataUsePayload('Video URL product', productId, payload, `${valueVideoProduct.source}`, editProduct, reloadProduct)
  }

  const showDataImage = (dataImageProduct) => {
    if (dataImageProduct.length > 0) {
      if (!adjustImagePosition) {
        const remapDataImage = dataImageProduct.map((val, index) => {
          return (
            <Paper p='md' shadow='xs' radius='md' withBorder mb='md' key={index}>
              <Flex justify='space-between' align='start'>
                <Flex gap='md' align='start'>
                  <Paper shadow="sm" w='auto' withBorder radius='md'>
                    <Image
                      radius="md"
                      h={100}
                      w={100}
                      fit="cover"
                      src={val.source}
                  />
                  </Paper>
                  <Box>
                    <Text fz='sm' fw='500'>Position Image: {val.position}</Text>
                    {val.is_default ? <Badge color="red" tt='capitalize'>Main Image</Badge> : ''}
                  </Box>
                </Flex>
                <Menu width={165} position="bottom-end" withArrow arrowPosition="center">
                  <Menu.Target>
                    <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
                      <IconDotsVertical stroke={1.5} />
                    </ActionIcon>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={<IconPencil stroke={1.5} size={14} />}
                      onClick={() => handlingSetMainPhoto(val.id)}
                      fw='600'
                      fz={11}
                      disabled={val.is_default}
                    >
                      Set as Main Photo
                    </Menu.Item>
                    <Menu.Item
                      color='red'
                      leftSection={<IconTrash stroke={1.5} size={14} />}
                      onClick={() => handlingDeleteImageProduct(val)}
                      fw='600'
                      fz={11}
                    >
                      Delete
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Flex>
            </Paper>
          )
        })

        return remapDataImage
      } else {
        return (
          <FormAdjustPositionImageProduct idProduct={productId} dataImage={dataImageProduct} quitAdjustPosition={handleQuitAdjustPosition} reloadList={reloadProduct} />
        )
      }
    } else {
      return <NoData />
    }
  }

  const showDataVideo = (dataVideoProduct) => {
    if (dataVideoProduct.length > 0) {
      const remapDataVideo = dataVideoProduct.map((val, index) => {
        return (
          <Paper p='md' shadow='xs' radius='md' withBorder mb='md' key={index}>
            <Flex justify='space-between' align='start'>
              <Flex gap='md' align='start'>
                <Paper shadow="sm" w='auto' withBorder radius='md'>
                  <Image
                    radius="md"
                    h={100}
                    w={100}
                    fit="cover"
                    src={val.thumbnail}
                />
                </Paper>
                <Box>
                  <Box mb={4}>
                    <Text fz={12} fw='500' mb={-4}>Video URL:</Text>
                    <Anchor fz={12} underline="hover" c='blue' fw='500'>{val.source}</Anchor>
                  </Box>
                  {val.is_default ? <Badge color="red" tt='capitalize'>Main Video</Badge> : ''}
                </Box>
              </Flex>
              <Menu width={165} position="bottom-end" withArrow arrowPosition="center">
                <Menu.Target>
                  <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
                    <IconDotsVertical stroke={1.5} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={<IconPencil stroke={1.5} size={14} />}
                    onClick={() => [setOpenModalAdjustVideo(true), setDetailData(val)]}
                    fw='600'
                    fz={11}
                  >
                    Edit
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconBrandYoutube stroke={1.5} size={14} />}
                    onClick={() => [setOpenModalPreviewVideo(true), setDetailData(val)]}
                    fw='600'
                    fz={11}
                  >
                    Preview Video
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconPencil stroke={1.5} size={14} />}
                    onClick={() => handlingSetMainVideo(val.id)}
                    fw='600'
                    fz={11}
                    disabled={val.is_default}
                  >
                    Set as Main Video
                  </Menu.Item>
                  <Menu.Item
                    color='red'
                    leftSection={<IconTrash stroke={1.5} size={14} />}
                    onClick={() => handlingDeleteVideoProduct(val)}
                    fw='600'
                    fz={11}
                  >
                    Delete
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          </Paper>
        )
      })
      return remapDataVideo
    } else {
      return <NoData />
    }
  }

  return (
    <Box>
      <Box mb={20} mt={10}>
        <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
          <Flex justify='space-between' align='center'>
            <Text fw={500}>
              Product Image
            </Text>
            <Group gap='md'>
              <Button size='xs' variant="outline" disabled={adjustImagePosition} onClick={() => setAdjustImagePosition(true)} >Adjust Position</Button>
              <Button size='xs' variant="filled" disabled={adjustImagePosition} onClick={() => setOpenModalAddImage(true)}>Add Image</Button>
            </Group>
          </Flex>
          <Divider my={10} />
          <Box my={20}>
            {isLoadingProduct ? <LoadingData/> : showDataImage(imageProduct)}
          </Box>
        </Paper>

        <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
          <Flex justify='space-between' align='center'>
            <Text fw={500}>
              Video (URL Youtube Only)
            </Text>
            <Group gap='md'>
              <Button size='xs' variant="filled" onClick={() => setOpenModalAdjustVideo(true)}>Add URL</Button>
            </Group>
          </Flex>
          <Divider my={10} />
          <Box my={20}>
            {isLoadingProduct ? <LoadingData/> : showDataVideo(videoProduct)}
          </Box>
        </Paper>
      </Box>

      <Modal opened={openModalAddImage} onClose={onCloseModalAddImage} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Add New Image Product</Text>} withCloseButton={false}>
        <FormAddImageProduct idProduct={productId} onCloseForm={onCloseModalAddImage} reloadDetail={reloadProduct} />
      </Modal>
      <Modal opened={openModalAdjustVideo} onClose={onCloseModalAdjustVideo} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>{detailData == null ? 'Add' : 'Update'} URL Video Product</Text>} withCloseButton={false}>
        <FormAdjustVideoProduct idProduct={productId} detail={detailData} onCloseForm={onCloseModalAdjustVideo} reloadDetail={reloadProduct} />
      </Modal>
      <Modal opened={openModalPreviewVideo} onClose={onCloseModalPreviewVideo} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Preview Video</Text>} withCloseButton={false}>
        <PreviewVideoProduct detailVideo={detailData} onCloseForm={onCloseModalPreviewVideo} />
      </Modal>
    </Box>
  )
}

export default ProductImageAndVideo